import { ChainIdEnum, NETWORK_MAP } from 'config/constants/network'
import Image from 'UIKit/Image'
import { ImageProps } from 'UIKit/Image/types'

const ChainLogo: React.FC<
  {
    network: ChainIdEnum
  } & ImageProps
> = ({ network, height = 12, width = 12, ...props }) => {
  const networkInfo = NETWORK_MAP?.[network].networkInfo

  return (
    networkInfo && (
      <Image
        {...props}
        src={networkInfo?.icon}
        alt={`${networkInfo?.displayName} LOGO`}
        width={width}
        height={height}
        style={{
          minWidth: width,
          minHeight: height,
          maxWidth: width,
          maxHeight: height,
          ...(props.style || {}),
        }}
      />
    )
  )
}

export default ChainLogo
